"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
// prettier-ignore
exports.theme = {
    light: true,
    scales: {
        //        25    50    100   200   300   400   500   600   700   800   900   950
        //        bg-1  bg-2  el-1  el-2  el-3  bd-1  bd-2  bd-3  sol-1 sol-2 txt-1 txt-2
        L: [99, 97, 90, 86, 82, 72, 64, 56, 50, 45, 24, 12],
        xS: [0.1, 0.2, 1, 0.9, 1.1, 1, 0.9, 1.1, 0.98, 1.02, 0.9, 0.8],
        dH: [-10, -6, -3, -2, -1, 0, 1, 2, 3, 4, 8, 10],
    },
    palette: {
        accent: [
            [250, 0.17], // oklch(66% 0.17 250)
            [35, 0.2], // oklch(66% 0.2 35)
        ],
        brand: [
            [150, 0.16], // oklch(66% 0.16 150)
            [250, 0.17], // oklch(66% 0.17 250)
            [290, 0.28], // oklch(66% 0.28 290)
            [350, 0.24], // oklch(66% 0.24 350)
            [35, 0.2], // oklch(66% 0.2 35)
        ],
        neutral: [
            [105, 0.01], // oklch(80% 0.1 105)
            [20, 0.01], // oklch(80% 0.1 20)
        ],
        success: [
            [140, 0.19], // oklch(66% 0.19 140)
        ],
        error: [
            [
                28,
                0.24,
                {
                    // oklch(66% 0.24 28)
                    scales: {
                        xS: [0.2, 0.3, 0.4, 1, 1, 1, 1, 1, 1, 1, 1, 1],
                    },
                },
            ],
        ],
        warning: [
            [96, 0.25], // oklch(66% 0.25 96)
        ],
        link: [
            [258, 0.22], // oklch(66% 0.22 258)
            [28, 0.24], // oklch(66% 0.24 28)
        ],
        ai: [
            [303, 0.29], // oklch(66% 0.29 303)
            [235, 0.15], // oklch(66% 0.15 235)
        ],
    },
    mapping: {
        bg: ['neutral', 0, 0, { L: 100 }],
    },
};
